// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/anpressfeder/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteAnpressfederDE: PageEntry = {
  id: "example.produkte-anpressfeder",
  locale: "de",
  slug: "produkte/anpressfeder",
  seo: {
    title: "Anpressfeder | Dietz GmbH",
    description: "Ausgleich von Längentoleranzen in einer im Fahrzeug verbauten Sitzbaugruppe. Geringster Materialverbrauch durch ein Folgeverbundkonzept ohne Pilotstreifen.",
  },
  type: "post",
  h1: "Anpressfeder",
  intro: "Ausgleich von Längentoleranzen in einer im Fahrzeug verbauten Sitzbaugruppe. Geringster Materialverbrauch durch ein Folgeverbundkonzept ohne Pilotstreifen.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_anpressfeder.jpg", alt: "Anpressfeder von DIETZ", width: 800, height: 640 }
  ],
};
